import WebMercatorViewport from 'viewport-mercator-project';
import { LngLat, LngLatBounds } from 'mapbox-gl';

const getCurrentMapBounds = (viewport: WebMercatorViewport, mapWidth: number, mapHeight: number): LngLatBounds => {
  const bounds = new LngLatBounds();

  try {
    const nw = viewport.unproject([0, 0]);
    const se = viewport.unproject([mapWidth, mapHeight]);

    if (nw && se) {
      bounds.extend(new LngLat(...nw));
      bounds.extend(new LngLat(...se));
    }
  } catch (error) {
    console.error('Error unprojecting coordinates:', error);
  }

  return bounds;
};

export default getCurrentMapBounds;
